<div class="page-section">
	<div class="page-heading-details-section">
		<div class="page-heading-section">
			<img src="assets/back.png" class="page-back-icon" (click)="back()" />
			<span>C Level Clients</span>
			<div class="section-heading-tooltip-block">
				<img src="assets/info-black.png" />
				<div class="section-heading-tooltip-section">
					<div class="module-page-information-section" *ngFor="let section of description_sections">
						<div class="each-module-page-information-section">
							<p class="each-module-page-information-heading">{{section.name}}</p>
						</div>
						<ng-container *ngIf="section.sub_sections">
							<ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
								<div class="each-module-page-information-sub-section">
									<p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p>
									<p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
									
									<ng-container *ngIf="sub_section.sub_sections">
										<div class="each-module-page-information-sub-section" *ngFor="let sub_section of sub_section.sub_sections; let index = index">
											<p class="each-module-page-information-sub-heading">{{index + 1}}) {{sub_section.name}}:</p>
											<p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
										</div>
									</ng-container>
									
								</div>
							</ng-container>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="page-content-section">
		<div class="page-tabs-section">
			<div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_tab == 'Assigned Clients' }" (click)="tabChange('Assigned Clients')" >
				<span>Assigned Clients ({{(tab_count_data.assigned_clients).toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT)}})</span>
			</div>
			<div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_tab == 'Unassigned Clients' }" (click)="tabChange('Unassigned Clients')" >
				<span>Unassigned Clients ({{(tab_count_data.unassigned_clients).toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT)}})</span>
			</div>
		</div>
		<div *ngIf="page_loaded">

			<div class="new-summary-section">
				<div class="each-new-summary-section">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data.total_clients) }}</p>
					<p class="each-new-summary-section-label">Total Clients</p>
				</div>
				<div class="each-new-summary-section">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_data.total_aum) }}</p>
					<p class="each-new-summary-section-label">Invested AUM</p>
				</div>
				<div class="each-new-summary-section">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_data.total_networth) }}</p>
					<p class="each-new-summary-section-label">Total Networth</p>
				</div>
			</div>

			<div class="optimize-charts-section" *ngIf="user_details.role.role == 4">
				<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="graphSlideConfig">
					<div ngxSlickItem class="each-dashboard-graph-block">
						<div class="portfolio-inner-heading-section">
							<img src="assets/events.png" class="portfolio-section-icon" />
							<span>By Advisor</span>
						</div>
						<div class="each-dashboard-graph-content">
							<div id="advisor-graph"></div>
						</div>
					</div>
				</ngx-slick-carousel>
			</div>

			<div>
				<div class="portfolio-inner-heading-section">
					<img src="assets/interaction-summary.png" class="portfolio-section-icon" />
					<span>Clients Summary</span>
				</div>
				<div class="leads-table-section">
					<div class="new-table-heading-section">
						<div class="mb-2">
							<span class="new-filter-tag" *ngIf="advisor_id != ''">
								{{ advisor_name }}
								<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" advisor_id = ''; advisor_name = ''; current_pagination_page = 1; getClientsData()" />
							</span>
						</div>
						<ng-container *ngIf="user_details.role.role == 4">
							<button class="move-button" style="margin-right: 16px; position: relative; top: 6px;" (click)="assignClients()" *ngIf="selected_tab == 'Unassigned Clients'">Assign</button>
							<button class="move-button" style="margin-right: 16px; position: relative; top: 6px;" (click)="unAssignClients()" *ngIf="selected_tab == 'Assigned Clients'">Unassign</button>
						</ng-container>
						<span style="visibility: hidden">Clients</span>
						<div class="new-table-actions ml-4">
							<div class="each-action-section search-input-section" *ngIf="show_search">
								<input
									type="text"
									placeholder="Search"
									class="search-input"
									[(ngModel)]="search_key"
									(input)="current_pagination_page = 1; getClientsData()"
								/>
								<span
									class="search-input-close"
									(click)="
									show_search = false;
									search_key = '';
									current_pagination_page = 1;
									getClientsData()">&times;
								</span>
							</div>
							<div class="each-action-section search-icon" *ngIf="!show_search" (click)="show_search = true">
								<img src="assets/search.png" class="button-icon" />
								<span>Search</span>
							</div>
							<div class="each-action-section dynamic-columns-section">
								<img
									src="assets/column-filter.png"
									class="button-icon"
									(click)="show_toggle_columns = !show_toggle_columns"
								/>
								<div class="dynamic-columns" *ngIf="show_toggle_columns">
									<div class="dynamic-column-heading-section">
										<span>Add Columns</span>
										<span class="columns-close" (click)="show_toggle_columns = false">&times;</span>
									</div>
									<div class="dynamic-column-content">
										<div class="each-column-section" *ngFor="let column of table_columns">
											<mat-checkbox [checked]="column.checked == true" (change)="column.checked = !column.checked">{{ column.name }}</mat-checkbox>
										</div>
									</div>
								</div>
							</div>
							<!-- <button class="move-button" (click)="moveToSalesProcess()">Move</button> -->
						</div>
					</div>
					<div class="new-table-v2-overflow">
						<!-- <table class="new-table"> -->
							<table class="new-table-v2">
								<thead>
									<tr>
										<!-- <th>
											<mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
										</th> -->
										<!-- <th>
											<div class="record-selection-section">
												<mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
											</div>
										</th> -->
										<th appColumnResizable>Actions</th>
										<ng-container *ngFor="let column of table_columns">
											<th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
										</ng-container>
									</tr>
								</thead>
								<ng-container *ngIf="table_data_loaded">
									<tbody *ngIf="table_data.length > 0">
										<ng-container
										*ngFor="
										let client of table_data
										| paginate
										: {
											id: 'prospects-data',
											itemsPerPage: pagination_records_limit,
											currentPage: current_pagination_page,
											totalItems: total_pagination_records
										};
										let clientIndex = index
										"
										>
										<tr>
											<!-- <td>
												<mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
											</td> -->
											<td>
												<div class="record-selection-section" *ngIf="user_details.role.role == 4">
													<mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
												</div>
												<img
												src="assets/view-tasks.png"
												class="client-table-icon"
												(click)="showUserProfile(client)"
												/>
											</td>
											<ng-container
											*ngFor="let column of table_columns"
											[ngSwitch]="column.key"
											>
											<ng-container *ngSwitchCase="'status'">
												<td *ngIf="column.checked">
													<p class="status-tag completed-status">
														{{ client.status }}
													</p>
												</td>
											</ng-container>
											<ng-container *ngSwitchCase="'ai_rank'">
												<td class="highlight-table-cell" *ngIf="column.checked">
													{{ getKey(client, column) }}
												</td>
											</ng-container>
											<ng-container *ngSwitchCase="'opportunity'">
												<td class="highlight-table-cell" *ngIf="column.checked">
													{{ getKey(client, column) }}
												</td>
											</ng-container>
											<ng-container
											*ngSwitchCase="'predicted_wallet_share_growth'"
											>
											<td class="highlight-table-cell" *ngIf="column.checked">
												{{ getKey(client, column) }}
											</td>
										</ng-container>
										<ng-container *ngSwitchCase="'predicted_closure_days'">
											<td class="highlight-table-cell" *ngIf="column.checked">
												{{ getKey(client, column) }} Day(s)
											</td>
										</ng-container>
										<ng-container *ngSwitchCase="'recommended_products'">
											<td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
												{{ getKey(client, column) }}
											</td>
										</ng-container>

										<ng-container *ngSwitchCase="'preferred_channel'">
											<td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
												{{ getKey(client, column) }}
											</td>
										</ng-container>

										<ng-container *ngSwitchCase="'type'">
											<td *ngIf="column.checked" [matTooltip]="getKey(client, column)">
												<span
												[ngClass]="{
													'need-attention-activity-status': getKey(client, column) == 'Retention',
													'new-leads-activity-status': getKey(client, column) == 'Client Engagement',
													'in-progress-activity-status': getKey(client, column) == 'Opportunity'
												}"
												>{{getKey(client, column)}}</span
												>
											</td>
										</ng-container>
										<ng-container *ngSwitchCase="'actions'">
											<td *ngIf="column.checked">
												<img
												src="assets/view-tasks.png"
												class="client-table-icon"
												(click)="openClientDataModal(client)"
												/>
											</td>
										</ng-container>
										<ng-container *ngSwitchCase="'trigger'">
											<td *ngIf="column.checked">
												<span [style.color]="client['trigger_type'] == 'AI' ? '#f3a638' : '#4cb64c'">{{ getKey(client, column) }}</span>
											</td>
										</ng-container>
										<ng-container *ngSwitchDefault>
											<td *ngIf="column.checked">
												{{ getKey(client, column) }}
											</td>
										</ng-container>
									</ng-container>
								</tr>
							</ng-container>
						</tbody>
						<tbody *ngIf="table_data.length == 0">
							<td colspan="10">
								<div class="zero-state-section">
									<span>No Data Found</span>
								</div>
							</td>
						</tbody>
					</ng-container>
					<ng-container *ngIf="!table_data_loaded">
						<tbody>
							<tr>
								<td
								colspan="15"
								class="zero-state-section"
								style="height: 120px"
								>
								<app-loader
								[loading_text]="'Loading Clients'"
								></app-loader>
							</td>
						</tr>
					</tbody>
					</ng-container>
					</table>
					</div>
					<!-- <div class="new-pagination-section"> -->
					<div class="new-table-v2-pagination-section">
						<span class="mx-4">{{ total_pagination_records | number:'1.0-0' }} Records</span>
						<mat-select
						class="pagination-input"
						[(ngModel)]="pagination_records_limit"
						(selectionChange)="current_pagination_page = 1; getClientsData()"
						>
						<mat-option [value]="10">10</mat-option>
						<mat-option [value]="100">100</mat-option>
						<mat-option [value]="500">500</mat-option>
						<mat-option [value]="1000">1000</mat-option>
					</mat-select>
					<!-- <div class="new-pagination-controls"> -->
						<div class="new-table-v2-pagination-controls">
							<pagination-controls
							id="prospects-data"
							(pageChange)="pageChanged($event)"
							style="text-align: right; position: relative; top: 6px"
							></pagination-controls>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="!page_loaded">
			<app-loader [loading_text]="'Loading C Level Clients'"></app-loader>
		</div>
	</div>
</div>

<ng-template #assignClientsModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section">
			<span>Assign Clients</span>
			<span class="page-modal-close-icon" (click)="closeAssignClientsModal()" >&times;</span
			>
		</div>
		<div class="page-modal-content-section">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Select Digital Relationship Manager *</p>
				<mat-select class="page-modal-input" [(ngModel)]="assigned_drm">
					<mat-option [value]="''">Select Digital Relationship Manager</mat-option>
					<mat-option *ngFor="let drm of drm_list" [value]="drm.id">{{drm.first_name}} {{drm.last_name}}</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="assigned_drm_error">Digital Relationship Manager is Required.</p>
			</div>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" *ngIf="!clients_loader" (click)="assignClientsData()">Save</button>
			<button class="page-modal-primary-button" *ngIf="clients_loader">Saving...</button>
			<button class="page-modal-secondary-button" (click)="closeAssignClientsModal()">Cancel</button>
		</div>
	</div>
</ng-template>

<ng-template #unAssignClientsModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section">
			<span>Unassign Clients</span>
			<span class="page-modal-close-icon" (click)="closeUnAssignClientsModal()" >&times;</span
			>
		</div>
		<div class="page-modal-content-section">
			<p class="page-modal-delete-description">Are you sure you want to Unassign Clients?</p>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" *ngIf="!clients_loader" (click)="unAssignClientsData()">Save</button>
			<button class="page-modal-primary-button" *ngIf="clients_loader">Saving...</button>
			<button class="page-modal-secondary-button" (click)="closeUnAssignClientsModal()">Cancel</button>
		</div>
	</div>
</ng-template>

<ng-container *ngIf="show_user_profile">
	<app-customer-profile [data]="user_profile_data" [client_type]="'Client'" (profileClosed)="profileClosed($event)"></app-customer-profile>
</ng-container>